import { get, post } from './api';
import { toastError, toastSuccess } from 'utils/reduxToast';

import { API_V4_BASE_URL } from 'settings';
import { ILesson } from 'interface/lesson';

export const fetchBannerOffers = (hash: string): Promise<ILesson> => {
  return get({
    url: `/learner/course/${hash}/offers`,
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => response.data.data)
    .catch(() => toastError('Não é possível encontrar ofertas no momento'));
};

export const fetchOffers = (lessonId: string): Promise<ILesson> => {
  return get({
    url: `/learner/lessons/${lessonId}/offers`,
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => response.data.data)
    .catch(() => toastError('Não é possível encontrar ofertas no momento'));
};

export const makeRenewal = (id: number) => {
  return post({
    url: '/learner/course/renewals',
    baseURL: API_V4_BASE_URL,
    data: { id },
  })
    .then((data) => {
      toastSuccess('Renovação realizada com sucesso!');
      return data;
    })
    .catch(() => toastError('Ocorreu um erro ao realizar a renovação'));
};
